import { render, staticRenderFns } from "./companyQuit.vue?vue&type=template&id=4eba85c3&scoped=true&"
import script from "./companyQuit.vue?vue&type=script&lang=js&"
export * from "./companyQuit.vue?vue&type=script&lang=js&"
import style0 from "./companyQuit.vue?vue&type=style&index=0&id=4eba85c3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eba85c3",
  null
  
)

export default component.exports